import {useState,useEffect} from 'react'
import { useCurrent, usePut,useFetch } from '../../../hooks';
import {langObjType,objLangTextHandler,LangArrayToObjKeyValue} from '../../../utils/global'
import { MwButton, MwSpinner } from '../../ui';
import CardHeadeWithActions from '../../ui/CardHeadeWithActions';
import TagForm from './TagForm';
import { useTranslation } from 'react-i18next';
import { normalizeApiItem } from '../productUi';

const EditTag = ({id,setMode}) => {
    const {currentLangList,currentTenantId,currentCompanyId,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [errors,setErrors] = useState({});
    const [loadingPage,setLoadingPage] = useState(true);
    const [t] = useTranslation('global')
    const {data:dataFetchTags} = useFetch(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/tags/show/${id}`);
    const {data:resultPut,putData} = usePut();

    const [isActive,setIsActive] = useState(true);
    const [tagName,setTagName] = useState(langObjType());
    const [tagDesc,setTagDesc] = useState(langObjType());

    const formValidate = () => {
        let errorObj = {};
        setErrors({});
        if(!tagName[currentLangId]){
            errorObj = { ...errorObj, [`tagName.${currentLangId}`] : t('product.Tagentered') };
            setFormLang(currentLangId)
        }

        if(Object.keys(errorObj).length !== 0 ){
            setErrors(errorObj)
            return true
        }
        return false;
    }

    const submitHandler = () => {
        const _data = {
            tagName: objLangTextHandler(tagName),
            tagDesc: objLangTextHandler(tagDesc),
            isActive,
            tenantId:currentTenantId,
            companyId:currentCompanyId
        }
        
        if(formValidate()) return;
        putData(`${process.env.REACT_APP_PRODUCTS_API_SERVER_BASE_URL}/tags/update/${id}`,_data);
    }

    useEffect(() =>{
        if(resultPut?.status === 1){
            setMode('List');
        }
    },[resultPut,setMode])

    useEffect(() =>{
        const tagItem = normalizeApiItem(dataFetchTags);
        if(tagItem){
            setTagName(LangArrayToObjKeyValue(tagItem.tagName))
            setTagDesc(LangArrayToObjKeyValue(tagItem.tagDesc))
            setIsActive(tagItem.isActive)
            setLoadingPage(false)
        }
    },[dataFetchTags]);

    return (
        <>
            { dataFetchTags && !loadingPage ? <div className='flex flex-col gap-3 px-3 text-sm text-slate-500' >
                <CardHeadeWithActions title={t('product.updateTag')}>
                    <MwButton type="saveBtn" inGroup={true} onClick = {()=>setMode('List')} > {t('product.manageTags')}  </MwButton>
                    <MwButton type="saveBtn" inGroup={true} onClick={submitHandler} >{t('product.save')}</MwButton>
                </CardHeadeWithActions>
                <TagForm
                    currentLangList={currentLangList}
                    formLang={formLang}
                    setFormLang={setFormLang}
                    errors={errors}
                    tagName={tagName}
                    setTagName={setTagName}
                    tagDesc={tagDesc}
                    setTagDesc={setTagDesc}
                    isActive={isActive}
                    setIsActive={setIsActive}
                />
            </div> : <MwSpinner/> }
        </> 
    )
}

export default EditTag
